export default __webpack_public_path__ + "ee57be36e828402c403060d594776aab.svg";